import { render, staticRenderFns } from "./hy_basic.vue?vue&type=template&id=31589aa5&scoped=true&"
import script from "./hy_basic.vue?vue&type=script&lang=js&"
export * from "./hy_basic.vue?vue&type=script&lang=js&"
import style0 from "./hy_basic.vue?vue&type=style&index=0&id=31589aa5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31589aa5",
  null
  
)

export default component.exports